module.exports = __webpack_public_path__ + "static/media/booksandwords-min.4ce43e5c.png";